module.exports = __webpack_public_path__ + "media/styles/images/png/circle-left-arrow-teal-9acd3a7d727f4a1474c27d9c868ecbb2.png";